/* TASKS */
export const REPORT_VALIDATE = "REPORT_VALIDATE"
export const REPORT_VALIDATE_SUCCESS = "REPORT_VALIDATE_SUCCESS"
export const REPORT_VALIDATE_FAIL = "REPORT_VALIDATE_FAIL"

export const REPORT_UPLOAD = "REPORT_UPLOAD"
export const REPORT_UPLOAD_SUCCESS = "REPORT_UPLOAD_SUCCESS"
export const REPORT_UPLOAD_FAIL = "REPORT_UPLOAD_FAIL"



